import React, { useEffect, useRef, useState } from "react";
import Steper from "../../../../components/d-reusable/Steper";
import CustomCard from "../../../../components/d-reusable/CustomCard";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
} from "antd";
import "../style.css";
import CustomPrimaryButton from "../../../../components/d-reusable/CustomPrimaryButton";
import CustomDefaultButton from "../../../../components/d-reusable/CustomDefaultButton";
import CustomDisabledScreen from "../../../../components/d-reusable/CustomDisabledScreen";
import TextArea from "antd/lib/input/TextArea";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { _onUpdateAmCaseField } from "../../../../../redux/actions/caseAction";
import { useLocation, useNavigate } from "react-router-dom";
import { createNewAM_Or_PmCaseForCurrentProject } from "../../../../../components/https/projects-apis";
import { errorRequestHandel } from "../../../../../helper";
import FindAgeUsingSecondOpinion from "../children/second-opinion/FindAgeUsingSecondOpinion";
import { usePermissionGuard } from "../../../../../hooks/project-hooks/usePermissionGuard";
import { useSubscriptionGuard } from "../../../../../hooks/subscription-hook/UseSubscriptionGuard";
const { Option } = Select;

const steps = ["Subject Information", "Clinical Evaluation"];

const AMCaseRegistration = () => {
  usePermissionGuard(); // Hook protects this route
  useSubscriptionGuard();

  const location = useLocation();
  const { type, projectId, caseId } = location.state || {}; // Destructure state values

  const scrollRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [activeStep, setActiveStep] = useState(0);
  const [isDateOrDob, setIsDateOrDob] = useState("");
  const [hasSubscription, setHasSubscription] = useState(false);
  const [isDob, setIsDob] = useState(true);
  const [loading, setLoading] = useState(false);
  const { amCase } = useSelector((state) => state.cases);
  const { dropdowns, countriesList = [] } = useSelector(
    (state) => state.general
  );

  const subjectInformation = amCase?.subjectInformation || {};
  const clinicalInformation = amCase?.clinicalInformation || {};

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [location]);

  const onNext = () => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    setActiveStep(1);
  };
  const onBack = () => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    setActiveStep(0);
  };

  useEffect(() => {
    if (caseId) {
      if (subjectInformation?.age_years.trim() !== "") {
        setIsDob(false);
      }
      setIsDateOrDob("fill");
    }
  }, [caseId]);

  const handleValuesChange = (changedValues, allValues) => {
    const [field, value] = Object.entries(changedValues)[0];
    const section =
      field in subjectInformation
        ? "subjectInformation"
        : "clinicalInformation";

    dispatch(_onUpdateAmCaseField(section, field, value));
  };

  const onFinish = async () => {
    if (isDob && subjectInformation?.dob) {
      subjectInformation.age_years = "";
    } else if (!isDob && subjectInformation?.age_years) {
      subjectInformation.dob = "";
    }

    setLoading(true);
    const formattedDOB = subjectInformation?.dob
      ? moment(subjectInformation.dob).format("YYYY-MM-DD")
      : null;
    const formattedDOR = subjectInformation?.date_of_records
      ? moment(subjectInformation.date_of_records).format("YYYY-MM-DD")
      : null;

    const data = {
      project_id: projectId,
      ...clinicalInformation,
      ...subjectInformation,
      dob: formattedDOB,
      date_of_records: formattedDOR,
      ...(caseId ? { id: caseId } : {}), // Add id key if caseId is non-zero
    };

    await onCreateCase(data);
  };

  const onCreateCase = async (payload) => {
    try {
      setLoading(true);
      const resposne = await createNewAM_Or_PmCaseForCurrentProject({
        type: type,
        payload: payload,
      });
      if (resposne.status == 200) {
        message.success("AM Case has been created successfully");
        setLoading(false);
        navigate(-1);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };

  const handleDobChange = (date) => {
    if (date) {
      setIsDateOrDob("dob"); // Set the state to "dob" when Date of Birth is selected
    } else if (!form.getFieldValue("age_years")) {
      setIsDateOrDob(""); // Reset if both fields are empty
    }
  };

  const handleAgeChange = (event) => {
    const value = event.target.value;
    if (value) {
      setIsDateOrDob("age_years"); // Set the state to "age_years" when Age is entered
    } else if (!form.getFieldValue("dob")) {
      setIsDateOrDob(""); // Reset if both fields are empty
    }
  };

  return (
    <div className="d-case_registration" ref={scrollRef}>
      <CustomDisabledScreen loading={loading} />

      <CustomCard>
        <div className="d-case_form">
          <Form
            layout="vertical"
            className="basic_antForm"
            initialValues={{
              ...subjectInformation,
              ...clinicalInformation,
              dob: subjectInformation?.dob
                ? moment(subjectInformation?.dob)
                : null,
              date_of_records: subjectInformation?.date_of_records
                ? moment(subjectInformation?.date_of_records)
                : null,
            }}
            onFinish={onFinish}
            onValuesChange={handleValuesChange}
          >
            <Row gutter={[20, 5]}>
              <Col md={12}>
                <Form.Item
                  label={"Full Name"}
                  name="full_name"
                  rules={[
                    { required: true, message: "This field is required" }, // Validation rules
                  ]}
                >
                  <Input placeholder="Full Name" />
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item label="Stated Age" style={{ marginBottom: 0 }}>
                  <Row gutter={[10, 10]} align="middle">
                    <Col span={18}>
                      {isDob ? (
                        <DatePicker
                          placeholder="Date of Birth"
                          style={{
                            width: "100%",
                            height: "43px",
                            marginTop: 5,
                            marginBottom: 5,
                          }}
                          onChange={handleDobChange}
                          disabledDate={(current) =>
                            current && current > moment().endOf("day")
                          }
                        />
                      ) : (
                        <Input
                          placeholder="Age in Years"
                          type="number"
                          onChange={handleAgeChange}
                        />
                      )}
                    </Col>
                    <Col span={6}>
                      <Checkbox
                        checked={!isDob}
                        onChange={(e) => setIsDob(!isDob)}
                      >
                        Age in Years
                      </Checkbox>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>

              {/* <Col md={12}>
                <Row gutter={[10, 10]} align={"middle"}>
                  {isDob ? (
                    <Col md={24}>
                      <Form.Item label="Stated Age" name="dob">
                        <DatePicker
                          placeholder="Date of Birth"
                          style={{ width: "100%", marginTop: 5 }}
                          onChange={(date) => handleDobChange(date)}
                          disabledDate={(current) =>
                            current && current > moment().endOf("day")
                          } // Disable future dates
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <Col md={24}>
                      <Form.Item
                        label="Stated Age"
                        name="age_years"
                        dependencies={["dob"]}
                      >
                        <Input
                          placeholder="Age in Years"
                          type="number"
                          onChange={(event) => handleAgeChange(event)}
                        />
                      </Form.Item>
                    </Col>
                  )}
                </Row>
                <Checkbox
                  checked={!isDob}
                  onChange={(e) => setIsDob(!isDob)}
                  style={{ position: "relative", top: -7 }}
                >
                  Age in Years
                </Checkbox>
              </Col> */}
            </Row>
            <br />
            <Row gutter={[20, 5]}>
              <Col md={12}>
                <Form.Item label="Nationality" name="nationality">
                  <Select
                    placeholder="Select"
                    showSearch
                    optionFilterProp="children" // Enables filtering based on the Option's text
                    filterOption={(input, option) =>
                      option?.children
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    } // Custom filter function
                  >
                    {countriesList?.map((item, index) => {
                      return (
                        <Option value={item.id} key={index}>
                          {item?.nice_name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item label="Identity Type" name="identity_type">
                  <Select>
                    {dropdowns?.identity_type?.map((item, index) => {
                      return (
                        <Option value={item.value} key={index}>
                          {item.value}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item
                  label="Gender"
                  name="gender"
                  rules={[
                    { required: true, message: "This field is required" }, // Validation rules
                  ]}
                >
                  <Select placeholder="Select">
                    {dropdowns?.gender?.map((item, index) => {
                      return (
                        <Option value={item.value} key={index}>
                          {item.value}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item label="Identity Code" name="identity_code">
                  <Input placeholder="Enter Code" />
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item label="Ethnicity" name="ethnicity">
                  <Select placeholder="Select">
                    {dropdowns?.ethnicity?.map((item, index) => {
                      return (
                        <Option value={item.value} key={index}>
                          {item.value}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col md={12}>
                <Form.Item
                  label="Date of Records"
                  name="date_of_records"
                  rules={[
                    { required: true, message: "This field is required" }, // Validation rules
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", marginTop: 4 }}
                    placeholder="Date"
                    disabledDate={(current) =>
                      current && current > moment().endOf("day")
                    } // Disable future dates
                  />
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item
                  name="medical_history"
                  label="Medical & Identifying Marks"
                >
                  <TextArea
                    className="form_basic_text_area"
                    placeholder="Write medical & identifying marks"
                  />
                </Form.Item>
              </Col>

              <Col md={12}>
                <Form.Item name="source_of_records" label="Source of Records">
                  <TextArea
                    className="form_basic_text_area"
                    placeholder="Source of records"
                  />
                </Form.Item>
              </Col>
            </Row>

            <br />

            <Row justify={"start"} gutter={[20, 20]}>
              <Col>
                <CustomPrimaryButton
                  title={"Save"}
                  type={"submit"}
                  isLoading={loading}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </CustomCard>
    </div>
  );
};

export default AMCaseRegistration;

{
  /* <Row gutter={[20, 40]}>
                  <Col md={4}></Col>

                  <Col md={12}>
                    <FindAgeUsingSecondOpinion
                      onAction={() => setHasSubscription(!hasSubscription)}
                      hasSubscription={hasSubscription}
                    />
                  </Col>
                </Row> */
}
